<template>
	<div class="is-divider"></div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		content() {
			return this.data.content;
		}
	}
};
</script>

<style scoped></style>
